/**
 * documentVersions.js
 * Current version of each public legal document.
 *
 * The version string IS the document's "Last Updated" date, in ISO form. Both
 * TermsOfService.js and PrivacyPolicy.js derive their rendered "Last Updated"
 * line from these values via formatDocumentDate(), so the date a user reads and
 * the version recorded against their acceptance cannot disagree.
 *
 * The backend mirrors these values in ckg3-backend/config/documents.js. The
 * server records acceptances at ITS OWN versions and never trusts a version
 * sent by the client — these two files must be updated together.
 *
 * When a document changes materially: bump its value here and in the backend
 * mirror. Every user's stored acceptance will then no longer match the current
 * version, and the acceptance gate will ask them again on next login.
 */

export const DOCUMENT_VERSIONS = {
  tos: '2026-08-06',
  privacy: '2026-08-06'
};

/**
 * Render an ISO version string as display prose, e.g. '2026-08-06' →
 * 'August 6, 2026'. Parsed as local time — new Date('2026-08-06') would be
 * treated as UTC midnight and can render as the previous day west of Greenwich.
 *
 * @param {string} isoDate - version string in YYYY-MM-DD form
 * @returns {string} formatted date, or the raw input if it cannot be parsed
 */
export const formatDocumentDate = (isoDate) => {
  if (!isoDate) return '';
  const parsed = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return isoDate;
  return parsed.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export default DOCUMENT_VERSIONS;
